import { render } from "./RecordTile.vue?vue&type=template&id=10f45eb8"
import script from "./RecordTile.vue?vue&type=script&setup=true&lang=js"
export * from "./RecordTile.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Sources/JavaScript/Mask/Tiles/components/RecordTile.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "10f45eb8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('10f45eb8', __exports__)) {
    api.reload('10f45eb8', __exports__)
  }
  
  module.hot.accept("./RecordTile.vue?vue&type=template&id=10f45eb8", () => {
    api.rerender('10f45eb8', render)
  })

}


export default __exports__